<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{$t($route.meta.title)}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add
                                @invoke-method="invokeMethod($event)"
                                action="showProductionProcedure"
                            ></bc-btn-add>
                            <!-- <bc-reorder
                                v-if="!!$route.query.line_id"
                                ref="reorder"
                                :items="production_procedures"
                                primary-id="procedure_id"
                            >
                                <template slot-scope="{ item, index }">
                                    {{ `${!!item.sort_order ? item.sort_order : index} - ${item.procedure_name}` }}
                                </template>
                            </bc-reorder> -->
                            <bc-btn-refresh
                                @invoke-method="dbGetProductionProcedures()"
                            ></bc-btn-refresh>
                            <bc-search-menu
                                :params="axiosParams"
                                @open="getArrayData()"
                            >
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input
                                            v-model="filter.search"
                                            :params="axiosParams"
                                        ></bc-search-input>
                                    </v-list-tile>

                                    <v-list-tile class="mb-3">
                                        <bc-autocomplete
                                            v-model="filter.line_id"
                                            :label="$t('lang.line_id')"
                                            :items="production_lines"
                                            item-value="line_id"
                                            item-text="production_line"
                                            prepend-icon="multiple_stop"
                                            single-line
                                            clearable
                                            @click:clear="filterClearInput()"
                                            persistent-hint
                                            hint="Selecting line allows re-order"
                                        ></bc-autocomplete>
                                    </v-list-tile>
                                    <v-divider></v-divider>

                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav
                                @invoke-method="invokeMethod($event)"
                                :mobile-list="mobile_list"
                            ></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table
                        :headers="headers"
                        :items="production_procedures"
                        :no-data-text="$t('lang.no_results_matching')"
                        hide-actions
                    >
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="showProductionProcedure(props.item)">
								<td>{{ props.item.production_line }}</td>
								<td>{{ props.item.procedure_name }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination
                        :page="page"
                        :params="axiosParams"
                        name="settings_production_procedures"
                    ></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="production_procedure_dialog">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ currObjField('procedure_id') ? $t('lang.edit_production_procedure') : $t('lang.add_production_procedure') }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            action="closeProductionProcedureDialog"
                            :dialog-status="production_procedure_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="production_procedure">
                            <v-container grid-list-form>
                                <v-layout row wrap>
									<v-flex xs12>
										<bc-autocomplete
											:focus="production_procedure_dialog"
											v-model="production_procedure.line_id"
											:label="`${$t('lang.line_id')} *`"
											:items="production_lines"
                                            item-value="line_id"
                                            item-text="production_line"
											:rules="ifValid('production_procedure.line_id')"
										></bc-autocomplete>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											v-model="production_procedure.procedure_name"
											:label="`${$t('lang.procedure_name')} *`"
											:counter="showCounter(production_procedure.procedure_name, 'production_procedure.procedure_name')"
											:rules="ifValid('production_procedure.procedure_name')"
										></v-text-field>
									</v-flex>

                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn v-if="currObjField('procedure_id')" color="error" @mouseup.left="$refs.delete_production_procedure.openDialog()">{{ $t('lang.delete') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="closeProductionProcedureDialog()">{{$t('lang.cancel')}}</v-btn>
                        <v-btn color="success" @mouseup.left="modifyProductionProcedure(currObjField('procedure_id') ? 'patch' : 'post', currObjField('procedure_id'))">{{$t('lang.save')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_production_procedure"
                :heading="$t('lang.delete_production_procedure')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="modifyProductionProcedure('delete', currObjField('procedure_id'))"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            headers: [
                { text: this.$t("lang.line_id"), sortable: false, width: "50%" },
                { text: this.$t("lang.procedure_name"), sortable: false, width: "50%" },
            ],

            production_procedure: {
                line_id: "",
                procedure_name: "",
            },
            current_obj: null,
            filter: {
                search: "",
                line_id: "",
                page_size: 0,
                page_num: 0,
            },
            production_procedure_dialog: false,
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "showProductionProcedure" },
                { title: this.$t("lang.refresh"), action: "dbGetProductionProcedures" },
                // { title: this.$t('lang.reorder'), action: "openDialog", ref: "reorder" },
            ],
            dbGetProductionProcedures: _.debounce(this.getProductionProcedures, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchProduction", {
                url: "production_procedures",
                method: "get",
                stateProperty: "production_procedures",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.production_procedures) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.$store
            .dispatch("fetchProduction", {
                url: "production_procedures",
                method: "get",
                stateProperty: "production_procedures",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.production_procedures) {
                    this.setQuery(parsedQuery, this.filter, this.default_filter);
                    this.finishLoader();
                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    computed: {
        ...mapState({
            rules_production_procedure: (state) => state.validation.rules_production_procedure,
            default_filter: (state) => state.production.production_procedures_filter,
            page: (state) => state.production.page,
            production_procedures: (state) => state.production.production_procedures,
            production_lines: (state) => state.production.production_lines,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
        currObjField() {
            return (field) => {
                return this.current_obj && field && this.current_obj[field] ? this.current_obj[field] : "";
            };
        },
    },
    methods: {
        getArrayData() {
            if (this.production_lines == null) this.getProductionLines();
        },
        getProductionLines() {
            this.$store
                .dispatch("fetchProduction", {
                    url: "production_lines",
                    method: "get",
                    stateProperty: "production_lines",
                    commit: true,
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                });
        },
        closeProductionProcedureDialog() {
            this.production_procedure_dialog = false;
            this.$refs.delete_production_procedure.close();
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        getProductionProcedures() {
            this.startLoader();
            this.$store
                .dispatch("fetchProduction", {
                    url: "production_procedures",
                    method: "get",
                    stateProperty: "production_procedures",
                    commit: true,
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.production_procedure_dialog = false;
                    this.$store.commit("toggleModalLoader", false);
                    this.$store.commit("validationOff");
                    this.finishLoader(true);
                });
        },
        modifyProductionProcedure(method = null, id = null) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("production_procedure")) {
                        this.$store.commit("toggleModalLoader", true);
                        this.$store
                            .dispatch("fetchProduction", {
                                pk: "procedure_id",
                                id: id,
                                url: `production_procedures/${id ? id : ""}`,
                                method: method,
                                stateProperty: "production_procedures",
                                mutate: true,
                                body: this.production_procedure,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.closeProductionProcedureDialog();
                                } else {
                                    this.$store.commit("toggleModalLoader", false);
                                }
                            });
                    }
                });
            }
        },
        showProductionProcedure(item = null) {
            this.current_obj = item;
            this.getArrayData();
            if (this.$refs.production_procedure) item ? this.$refs.production_procedure.resetValidation() : this.$refs.production_procedure.reset();

            this.$nextTick(() => {
                this.assignObj(this.production_procedure, item, this.rules_production_procedure);
                this.production_procedure_dialog = true;
            });
        },
    },
};
</script>
